export const DATA_DISCOUNT_VALUE = 1
